import { useMutation } from '@hooks/reactQuery';

import { getConfigurationTemplateConfigTree } from '@api/configurationTemplates';

import { createSettledPathHandler } from '@components/routes/CmModule/ConfigurationComparison/MOTreeMavenir/utils';

import { TGoldenSettingsConfigTreeDTO } from '@interfaces/cmModule/dto/goldenSettingsDTO';
import { IGoldenSettingsTree } from '@interfaces/cmModule/goldenSettings';
import {
	IMavenirSelectChangeCallback,
} from '@components/routes/CmModule/ConfigurationComparison/MOTreeMavenir/FlatTreeMavenir/interfaces';

import { GOLDEN_SETTING_TREE_BY_PATH } from '@constants/queryKeys';

const useMutateConfigurationTemplateTreeByPath = () => {
	const {
		isLoading,
		mutateAsync: getConfigForPath,
	} = useMutation<TGoldenSettingsConfigTreeDTO, IGoldenSettingsTree>({
		mutationKey: [GOLDEN_SETTING_TREE_BY_PATH],
		mutationFn: async ({ dumpId, path, setData, node }: IMavenirSelectChangeCallback) => {
			const data = await getConfigurationTemplateConfigTree({ dumpId, path });

			if (node) {
				createSettledPathHandler({ data, setData, node });
			}
		},
	});

	return {
		getConfigForPath,
		isLoadingGetConfigForPath: isLoading,
	};
};

export default useMutateConfigurationTemplateTreeByPath;
